(function () {
  const header = document.querySelector('[data-header]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  const toast = document.querySelector('[data-toast]');
  let toastTimer;

  if (header) {
    const updateHeader = () => header.classList.toggle('is-solid', window.scrollY > 30);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('is-locked', isOpen);
    });

    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        nav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('is-locked');
      });
    });
  }

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3400);
  };

  const updateBagCount = (itemCount) => {
    document.querySelectorAll('[data-bag-count]').forEach((count) => {
      count.textContent = String(itemCount);
      if (count.classList.contains('cart-float__count')) count.hidden = itemCount < 1;
    });
  };

  const bindQuantityControls = (root = document) => {
    root.querySelectorAll('[data-quantity-control]').forEach((control) => {
      if (control.dataset.quantityBound) return;
      const input = control.querySelector('[data-quantity-input]');
      const decrease = control.querySelector('[data-quantity-decrease]');
      const increase = control.querySelector('[data-quantity-increase]');
      if (!input || !decrease || !increase) return;

      const normalizeInput = () => {
        const minimum = Number(input.min || 1);
        const maximum = Number(input.max || Infinity);
        const value = Number.parseInt(input.value, 10);
        input.value = String(Math.min(maximum, Math.max(minimum, Number.isFinite(value) ? value : minimum)));
      };

      const changeQuantity = (amount) => {
        normalizeInput();
        input.value = String(Number(input.value) + amount);
        normalizeInput();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      decrease.addEventListener('click', () => changeQuantity(-1));
      increase.addEventListener('click', () => changeQuantity(1));
      input.addEventListener('blur', normalizeInput);
      control.dataset.quantityBound = 'true';
    });
  };

  const bindProductForms = (root = document) => {
    root.querySelectorAll('[data-product-card-form]').forEach((form) => {
      if (form.dataset.productBound) return;
      const submit = form.querySelector('[data-product-add]');
      const purchase = form.closest('[data-cart-url]');
      if (!submit || !purchase) return;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        submit.disabled = true;
        form.setAttribute('aria-busy', 'true');
        const action = form.action.endsWith('.js') ? form.action : `${form.action}.js`;
        const formData = new FormData(form);
        try {
          const response = await fetch(action, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
          if (!response.ok) throw new Error('add-to-cart');
          const cartResponse = await fetch(`${purchase.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('cart');
          const cart = await cartResponse.json();
          updateBagCount(cart.item_count);
          showToast(purchase.dataset.addSuccess);
          const quantityInput = form.querySelector('[data-quantity-input]');
          if (quantityInput) quantityInput.value = '1';
        } catch (error) {
          showToast(purchase.dataset.addError);
        } finally {
          submit.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
      form.dataset.productBound = 'true';
    });
  };

  document.querySelectorAll('[data-toast-message]').forEach((element) => {
    element.addEventListener('click', (event) => {
      if (element.tagName === 'A' && element.getAttribute('href') !== '#') return;
      event.preventDefault();
      showToast(element.dataset.toastMessage || 'Thanks for reaching out.');
    });
  });

  document.querySelectorAll('[data-demo-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const message = form.dataset.successMessage || 'Thank you. We will be in touch shortly.';
      showToast(message);
      form.reset();
    });
  });

  document.querySelectorAll('[data-clear-cart]').forEach((button) => {
    button.addEventListener('click', async (event) => {
      if (!window.confirm(button.dataset.clearConfirm)) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(button.dataset.clearCartUrl, { method: 'POST', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('clear-cart');
        window.location.reload();
      } catch (error) {
        button.removeAttribute('aria-busy');
        showToast(button.dataset.clearError);
      }
    });
  });

  const languageButtons = document.querySelectorAll('[data-language]');
  languageButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const language = button.dataset.language;
      languageButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      document.documentElement.lang = language;
      document.querySelectorAll('[data-en][data-es]').forEach((element) => {
        element.textContent = element.dataset[language] || element.dataset.en;
      });
    });
  });

  document.querySelectorAll('[data-live-search]').forEach((form) => {
    const section = form.closest('section');
    const input = form.querySelector('[data-live-search-input]');
    const results = section && section.querySelector('[data-live-search-results]');
    const resultsGrid = section && section.querySelector('[data-live-search-grid]');
    const status = section && section.querySelector('[data-live-search-status]');
    const productData = section && section.querySelector('[data-collection-products]');
    const defaultGrid = section && section.querySelector('[data-collection-grid]');
    const pagination = section && section.querySelector('[data-collection-pagination]');

    if (!input || !results || !resultsGrid || !status || !productData || !defaultGrid) return;

    let products;
    try {
      products = JSON.parse(productData.textContent);
    } catch (error) {
      return;
    }

    const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));

    const renderProduct = (product) => {
      const image = product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.alt || product.title)}" loading="lazy">` : '<span aria-hidden="true"></span>';
      const cartAddUrl = product.cart_url ? `${String(product.cart_url).replace(/\/$/, '')}/add` : '';
      const purchase = product.available && product.variant_id && cartAddUrl ? `<div class="product-card__purchase" data-cart-url="${escapeHtml(product.cart_url)}" data-add-success="${escapeHtml(product.add_success)}" data-add-error="${escapeHtml(product.add_error)}"><form class="product-card__form" action="${escapeHtml(cartAddUrl)}" method="post" data-product-card-form><input type="hidden" name="id" value="${escapeHtml(product.variant_id)}"><div class="product-card__purchase-row"><div class="quantity-control" data-quantity-control><label class="visually-hidden" for="SearchProductQuantity-${escapeHtml(product.variant_id)}">${escapeHtml(product.quantity_for)}</label><button class="quantity-control__button" type="button" data-quantity-decrease aria-label="${escapeHtml(product.decrease_label)}">−</button><input class="quantity-control__input" id="SearchProductQuantity-${escapeHtml(product.variant_id)}" type="number" name="quantity" min="1" value="1" inputmode="numeric" data-quantity-input><button class="quantity-control__button" type="button" data-quantity-increase aria-label="${escapeHtml(product.increase_label)}">+</button></div><button class="button button--forest product-card__add" type="submit" name="add" data-product-add>${escapeHtml(product.add_label)} <span aria-hidden="true">→</span></button></div></form></div>` : `<p class="product-card__sold-out">${escapeHtml(product.sold_out)}</p>`;
      return `<article class="product-card"><a href="${escapeHtml(product.url)}" aria-label="${escapeHtml(product.title)}"><div class="product-card__image">${image}</div></a><div class="product-card__meta"><div><span class="product-card__category">${escapeHtml(product.category)}</span><h3><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h3></div><span class="product-card__price">${escapeHtml(product.price)}</span></div>${purchase}</article>`;
    };

    const showDefaultProducts = () => {
      defaultGrid.hidden = false;
      if (pagination) pagination.hidden = false;
      results.hidden = true;
      resultsGrid.replaceChildren();
      status.textContent = '';
    };

    const updateResults = () => {
      const rawQuery = input.value.trim();
      if (!rawQuery) {
        showDefaultProducts();
        return;
      }

      const query = normalize(rawQuery);
      const terms = query.split(/\s+/).filter(Boolean);
      const matches = products.map((product) => {
        const title = normalize(product.title);
        const category = normalize(product.category);
        const searchText = normalize(product.search);
        let score = 0;
        for (const term of terms) {
          if (title.includes(term)) score += 8;
          else if (category.includes(term)) score += 5;
          else if (searchText.includes(term)) score += 2;
          else return { product, score: -1 };
        }
        if (title.startsWith(query)) score += 4;
        return { product, score };
      }).filter((match) => match.score >= 0).sort((first, second) => second.score - first.score || first.product.title.localeCompare(second.product.title));

      defaultGrid.hidden = true;
      if (pagination) pagination.hidden = true;
      results.hidden = false;
      status.textContent = matches.length === 1 ? `1 ${form.dataset.searchSingular}` : `${matches.length} ${form.dataset.searchPlural}`;
      resultsGrid.innerHTML = matches.length ? matches.slice(0, 6).map(({ product }) => renderProduct(product)).join('') : `<p class="collection-search__empty">${escapeHtml(form.dataset.searchEmpty)}</p>`;
      bindQuantityControls(resultsGrid);
      bindProductForms(resultsGrid);
    };

    input.addEventListener('input', updateResults);
    form.addEventListener('submit', (event) => {
      if (input.value.trim()) {
        event.preventDefault();
        updateResults();
      }
    });
  });

  bindQuantityControls();
  bindProductForms();
})();
